import LoadImage from "../commons/LoadImage";
import { Group, Text, Rect, Line, Circle } from "react-konva";

// canvas utility functions
const cursorPoint = (e) => {
    const container = e.target.getStage().container();
    container.style.cursor = 'pointer';
};

const cursorNormal = (e) => {
    const container = e.target.getStage().container();
    container.style.cursor = 'default';
};

const handleStageWheel = (e) => {
    const stage = e.target;
    const scaleBy = 1.75;
    const oldScale = Math.min(Math.max(0.45, stage.scaleX()), 1.27);
    const stageId = e.target.id();
    let pointer = { x: 0, y: 0 };

    if (stageId === "iwane" || stageId === "ota" || stageId === "kiyomidai" || stageId === "fukida" || stageId === "hatazawa" || stageId === "junior" || stageId === "hatazawa" || stageId === "jozai" || stageId === "koshigaya" || stageId === "sayama" || stageId === "atsugi" || stageId === "akiruno") {
        pointer = stage.getPointerPosition();

        if (stageId === 'iwane' || stageId === "ota" || stageId === "fukida" || stageId === "hatazawa" || stageId === "koshigaya" || stageId === "sayama" || stageId === "atsugi" || stageId === "akiruno") {
            // exit on initial zoom outscale
            if ((oldScale <= 0.57) && (e.evt.deltaY > 0)) {
                return;
            }

            // exit on final zoom in scale
            if ((oldScale >= 0.8) && (e.evt.deltaY < 0)) {
                return;
            }
        }
        if (stageId === 'junior') {
            if ((oldScale <= 0.685) && (e.evt.deltaY > 0)) {
                return;
            }
            // exit on final zoom in scale
            if ((oldScale >= 1.37) && (e.evt.deltaY < 0)) {
                return;
            }
        }

        if (stageId === 'jozai') {
            if ((oldScale <= 0.57) && (e.evt.deltaY > 0)) {
                return;
            }
            // exit on final zoom in scale
            if ((oldScale >= 0.99) && (e.evt.deltaY < 0)) {
                return;
            }
        }
        if (stageId === 'kiyomidai') {
            if ((oldScale <= 0.5725) && (e.evt.deltaY > 0)) {
                return;
            }
            // exit on final zoom in scale
            if ((oldScale >= 1) && (e.evt.deltaY < 0)) {
                return;
            }
        }


    } else {
        return;
    }

    // exit on initial zoom outscale
    if ((oldScale <= 0.45) && (e.evt.deltaY > 0)) {
        return;
    }

    // exit on final zoom in scale
    if ((oldScale >= 0.8) && (e.evt.deltaY < 0)) {
        return;
    }

    const mousePointTo = {
        x: (pointer.x - stage.x()) / oldScale,
        y: (pointer.y - stage.y()) / oldScale,
    };
    const newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;

    stage.scale({ x: newScale, y: newScale });

    const newPos = {
        x: pointer.x - mousePointTo.x * newScale,
        y: pointer.y - mousePointTo.y * newScale,
    };
    stage.position(newPos);
};

const handleStageDragStart = (e) => {
    const container = e.target.getStage().container();
    container.style.cursor = 'grabbing';
};

const handleStageDragMove = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };

    const stageId = e.target.id();

    if (stageId === 'iwane') {

        if (scale <= 0.5) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.8 && scale <= 1.5) {

            if (axisX <= -1230) {
                axis.x = -1230;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.5 && scale <= 0.8) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= -200) {
                axis.y = -200;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else if (stageId === 'daini') {

        if (scale <= 0.5) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.8 && scale <= 1.5) {

            if (axisX <= -400) {
                axis.x = -400;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.5 && scale <= 0.8) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= -200) {
                axis.y = -200;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        // test school

        if (scale <= 0.5) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {

            if (axisX <= -1500) {
                axis.x = -1500;
            }

            if (axisY <= -9500) {
                axis.y = -9500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.8 && scale <= 1.5) {

            if (axisX <= -200) {
                axis.x = -200;
            }

            if (axisY <= -1100) {
                axis.y = -1100;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }


        e.target.setAbsolutePosition(axis);
    }
};

const handleStageDragMoveOta = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'ota') {

        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.875 && scale <= 1.5) {

            if (axisX <= -1000) {
                axis.x = -1000;
            }

            if (axisY <= -800) {
                axis.y = -800;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {

        if (scale < 0.5) {


            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -500) {
                axis.x = -500;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -800) {
                axis.x = -800;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};

const handleStageDragMoveSayama = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'sayama') {

        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.875 && scale <= 1.5) {

            if (axisX <= -1000) {
                axis.x = -1000;
            }

            if (axisY <= -800) {
                axis.y = -800;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveIwane = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'iwane') {

        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.875 && scale <= 1.5) {

            if (axisX <= -1000) {
                axis.x = -1000;
            }

            if (axisY <= -800) {
                axis.y = -800;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};

const handleStageDragMoveKoshigaya = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'koshigaya') {

        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.875 && scale <= 1.5) {

            if (axisX <= -1000) {
                axis.x = -1000;
            }

            if (axisY <= -800) {
                axis.y = -800;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveFukida = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'sayama') {

        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.875 && scale <= 1.5) {

            if (axisX <= -1000) {
                axis.x = -1000;
            }

            if (axisY <= -800) {
                axis.y = -800;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveHatazawa = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };

    const stageId = e.target.id();

    if (stageId === 'hatazawa') {

        if (scale <= 0.55) {


            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -700) {
                axis.x = -700;
            }
        }

        if (scale > 0.55 && scale <= 0.99) {

            if (axisX <= -900) {
                axis.x = -900;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.99 && scale <= 2) {

            if (axisX <= -2500) {
                axis.x = -2500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 100) {
                axis.y = 100;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveJunior = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'junior') {

        if (scale <= 0.685) {
            if (axisX <= -750) {
                axis.x = -750;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -800) {
                axis.x = -800;
            }
        }

        // if (scale > 0.685 && scale <= 0.685) {

        //     if (axisX <= 0) {
        //         axis.x = 0;
        //     }

        //     if (axisY <= 0) {
        //         axis.y = 0;
        //     }

        //     if (axisX >= 0) {
        //         axis.x = 0;
        //     }

        //     if (axisY >= 0) {
        //         axis.y = 0;
        //     }
        // }
        if (scale > 0.685 && scale <= 1.37) {

            if (axisX <= -1280) {
                axis.x = -1280;
            }

            if (axisY <= -600) {
                axis.y = -600;
            }

            if (axisX >= 200) {
                axis.x = 200;
            }

            if (axisY >= 50) {
                axis.y = 50;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveJozai = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'jozai') {

        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale > 0.3 && scale <= 0.875) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= -400) {
                axis.y = -400;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.8 && scale <= 1.5) {

            if (axisX <= -1050) {
                axis.x = -1050;
            }

            if (axisY <= -1200) {
                axis.y = -1200;
            }

            if (axisX >= 50) {
                axis.x = 50;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveKiyomidai = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };


    const stageId = e.target.id();

    if (stageId === 'kiyomidai') {

        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = -300;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -800) {
                axis.x = -800;
            }

        }

        if (scale > 0.5 && scale <= 0.8) {
            if (axisX <= -850) {
                axis.x = -850;
            }

            if (axisY <= -200) {
                axis.y = -200;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }


        if (scale > 0.8 && scale <= 1.5) {
            if (axisX <= -1240) {
                axis.x = -1240;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {

            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= 0) {
                axis.x = 0;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};

const cursorGrab = (e) => {
    const container = e.target.getStage().container();
    container.style.cursor = 'grab';
};
const handleStageDragMoveComn = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };

    const stageId = e.target.id();

    if (stageId === 'iwane') {

        if (scale <= 0.5) {
            if (axisX <= 0) {
                axis.x = -150;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
        }

        if (scale > 0.8 && scale <= 1) {

            if (axisX <= -800) {
                axis.x = -800;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.5 && scale <= 0.8) {

            if (axisX <= -730) {
                axis.x = -730;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale <= 0.5) {
            if (axisX <= 0) {
                axis.x = -150;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {
            if (axisX <= -800) {
                axis.x = -800;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.8 && scale <= 1.5) {
            if (axisX <= -2500) {
                axis.x = -2500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }


        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveOtaComn = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };

    const stageId = e.target.id();

    if (stageId === 'ota') {
        if (scale <= 0.57) {
            if (axisX <= 0) {
                axis.x = -150;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }

            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -700) {
                axis.x = -700;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {
            if (axisX <= -900) {
                axis.x = -900;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 50) {
                axis.x = 50;
            }

            if (axisY >= 10) {
                axis.y = 10;
            }
        }
        if (scale > 0.875 && scale <= 1.5) {
            if (axisX <= -700) {
                axis.x = -700;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            // if (axisX <= 0) {
            //     axis.x = -300;
            // }

            if (axisY <= 0) {
                axis.y = -150;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -800) {
                axis.x = -800;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -800) {
                axis.x = -800;
            }

            if (axisY <= 0) {
                axis.y = 0;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};

// canvas ui components
const verticalSickle = (x, y, length) => {
    return [x + 30, x + 20 + y, x + 30, x + 25 + y, x + 10, x + 25 + y, x + 30, x + 40 + y, x + 30, x + length]
};

const chiefMCCB = (x, y, title, innerText, bottomText) => {
    return <Group x={x} y={y}>
        <LoadImage src="/img/bottom3.png" x={50} width={676 / 2.5} height={761 / 2.5} />
        {/* left */}
        <Text x={0} y={125} width={50} height={20} text={"負荷"} padding={5} />
        <Text x={0} y={160} width={50} height={20} text={"負荷"} padding={5} />
        <Text x={0} y={195} width={50} height={20} text={"負荷"} padding={5} />
        <Text x={0} y={230} width={50} height={20} text={"負荷"} padding={5} />

        {/* right */}
        <Text x={320} y={125} width={50} height={20} text={"負荷"} padding={5} />
        <Text x={320} y={160} width={50} height={20} text={"負荷"} padding={5} />
        <Text x={320} y={195} width={50} height={20} text={"負荷"} padding={5} />
        <Text x={320} y={230} width={50} height={20} text={"負荷"} padding={5} />

        {/* inner */}
        <Text x={200} y={80} text={innerText} padding={5} lineHeight={0.75} />

        {/* bottom */}
        <Text x={30} y={310} text={bottomText} padding={5} />

        {/* top */}
        <Text x={70} y={-20} text={title} padding={5} />

    </Group>
}
const handleStageDragMoveFukidaComn = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };

    const stageId = e.target.id();

    if (stageId === 'fukida') {

        if (scale <= 0.58) {
            if (axisX <= -850) {
                axis.x = -850;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -800) {
                axis.x = -800;
            }
        }

        if (scale > 0.58 && scale <= 1.015) {

            if (axisX <= -900) {
                axis.x = -900;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 50) {
                axis.x = 50;
            }

            if (axisY >= 10) {
                axis.y = 10;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale <= 0.5) {
            if (axisX <= 0) {
                axis.x = -150;
            }

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
        }

        if (scale > 0.5 && scale <= 0.875) {
            if (axisX <= -800) {
                axis.x = -800;
            }

            if (axisY <= -580) {
                axis.y = -580;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        if (scale > 0.8 && scale <= 1.5) {
            if (axisX <= -2500) {
                axis.x = -2500;
            }

            if (axisY <= -1340) {
                axis.y = -1340;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }


        e.target.setAbsolutePosition(axis);
    }
};
const handleStageDragMoveJozaiComn = (e) => {

    const axisX = e.target.x();
    const axisY = e.target.y();
    const scale = e.target.scaleX();

    let axis = { x: e.target.x(), y: e.target.y() };

    const stageId = e.target.id();

    if (stageId === 'jozai') {

        if (scale <= 0.57) {

            if (axisY <= 0) {
                axis.y = -150;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
            if (axisX <= -200) {
                axis.x = -200;
            }
            if (axisX <= -400) {
                axis.x = -400;
            }
            if (axisX <= -600) {
                axis.x = -600;
            }
            if (axisX <= -800) {
                axis.x = -800;
            }
            if (axisX <= -900) {
                axis.x = -900;
            }
        }

        if (scale > 0.57 && scale <= 0.875) {
            if (axisX <= -900) {
                axis.x = -900;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 50) {
                axis.x = 50;
            }

            if (axisY >= 10) {
                axis.y = 10;
            }
        }
        if (scale > 0.875 && scale <= 1) {
            if (axisX <= -900) {
                axis.x = -900;
            }

            if (axisY <= -500) {
                axis.y = -500;
            }

            if (axisX >= 50) {
                axis.x = 50;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        e.target.setAbsolutePosition(axis);
        return;
    } else {
        if (scale < 0.5) {
            if (axisX <= -500) {
                axis.x = -500;
            }

            if (axisY <= -900) {
                axis.y = -900;
            }

            if (axisX >= 100) {
                axis.x = 100;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.5 && scale < 0.8) {
            if (axisX <= -1300) {
                axis.x = -1300;
            }

            if (axisY <= -1500) {
                axis.y = -1500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }

        if (scale >= 0.8) {
            if (axisX <= -100) {
                axis.x = -100;
            }

            if (axisY <= -3500) {
                axis.y = -3500;
            }

            if (axisX >= 0) {
                axis.x = 0;
            }

            if (axisY >= 0) {
                axis.y = 0;
            }
        }
        e.target.setAbsolutePosition(axis);
    }
};
const commDevice = (x, y) => {
    return <Group x={x} y={y}>
        {/* outer */}
        <Rect x={400} width={650} height={410} stroke="black" strokeWidth={1} />

        {/* <Rect x={230} y={330} width={70} height={20} stroke="black" strokeWidth={1} /> */}
        {/* <Text x={240} y={330} text={"日射計"} fontSize={10} padding={5} /> */}
        <LoadImage src="/img/light.png" x={240} y={320} width={100 / 1.5} height={76 / 1.5} />

        {/* Inner */}
        <Text x={450} y={30} text={"LAN"} padding={5} />
        <Text x={470} y={100} text={"LAN"} padding={5} />
        <Text x={470} y={250} text={"RS-485"} padding={5} />

        <Text x={700} y={30} text={"LAN"} padding={5} />
        <Text x={750} y={100} text={"LAN"} padding={5} />
        <Text x={700} y={170} text={"LAN"} padding={5} />
        <Text x={700} y={230} text={"LAN"} padding={5} />

        <Text x={840} y={30} text={"RS-485"} padding={5} />
        <Text x={590} y={230} text={"LAN"} padding={5} />
        <Text x={630} y={330} text={"LAN"} padding={5} />

        <Text x={1050} y={30} text={"RS-485"} padding={5} />
        <Text x={1050} y={100} text={"I/O 接点"} padding={5} />

        {/* Outer */}

        <Text x={310} y={295} text={"専用ケーブル"} padding={5} />
        <Text x={310} y={325} text={"専用ケーブル"} padding={5} />

        <Line stroke="blue" strokeWidth={1} points={[305, 345, 420, 345]} />
        <Line stroke="blue" strokeWidth={1} points={[305, 315, 420, 315]} />

        {/* top horizontal line */}
        <Line stroke="blue" strokeWidth={1} points={[250, 50, 1150, 50]} />
        <Line stroke="blue" strokeWidth={1} points={[470, 320, 470, 60, 610, 60]} />
        <Line stroke="blue" strokeWidth={1} points={[690, 60, 720, 60, 720, 120, 1150, 120]} />
        <Line stroke="blue" strokeWidth={1} points={[680, 65, 680, 190, 1150, 190]} />
        <Line stroke="blue" strokeWidth={1} points={[650, 65, 650, 250, 1150, 250]} />

        {/* vertical line */}
        <Line stroke="blue" strokeWidth={1} points={[630, 65, 630, 440]} />
        <Line stroke="blue" strokeWidth={1} points={[630, 440, 635, 420, 625, 425]} />

        {/* Inner */}
        {/* <Rect x={420} y={170} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" /> */}
        {/* <Text x={435} y={170} text={"RS485/\n\nLAN変換器"} padding={5} lineHeight={0.75} /> */}
        <LoadImage src="/img/converter.png" x={445} y={130} width={165 / 4} height={345 / 4} />

        <Rect x={420} y={310} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" />
        <Text x={435} y={310} text={"変換器"} padding={15} lineHeight={0.75} />

        {/* <Rect x={600} y={30} width={100} height={170} stroke="black" strokeWidth={1} fill="#d9e6ff" /> */}
        {/* <Text x={600} y={70} text={"イーサネット\n\nスイッチ"} padding={15} lineHeight={0.75} /> */}
        <LoadImage src="/img/switch.png" x={595} y={-3} width={512 / 4.5} height={512 / 4.5} />

        {/* <Rect x={580} y={280} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" /> */}
        {/* <Text x={600} y={280} text={"SEMS\n\nデバイス"} padding={8} lineHeight={0.75} /> */}
        <LoadImage src="/img/sems.png" x={585} y={260} width={119 / 1.5} height={102 / 1.5} />

        <Rect x={580} y={350} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" />
        <Text x={600} y={350} text={"モバイル\n\nルータ"} padding={8} lineHeight={0.75} />

        {/* rs and unit */}
        {/* <Rect x={750} y={30} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" /> */}
        {/* <Text x={770} y={30} text={"RS485/\n\nLAN変換器"} padding={5} lineHeight={0.75} /> */}
        <LoadImage src="/img/converter.png" x={790} y={5} width={165 / 4} height={345 / 4} />

        {/* <Rect x={900} y={30} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" /> */}
        {/* <Text x={915} y={30} text={"データ収集\n\nユニット"} padding={5} lineHeight={0.75} align="center" /> */}
        <LoadImage src="/img/dcunit.png" x={915} y={0} width={100} height={100} />

        {/* data manager */}
        <Rect x={900} y={100} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" />
        <Text x={920} y={100} text={"data\n\nmanager"} padding={5} lineHeight={0.75} align="center" />

        {/* UPS */}
        {/* <Rect x={900} y={350} width={100} height={40} stroke="black" strokeWidth={1} fill="#d9e6ff" /> */}
        {/* <Text x={920} y={350} text={"UPS"} padding={15} lineHeight={0.75} align="center" /> */}
        <LoadImage src="/img/ups.png" x={900} y={300} width={100} height={100} />

        {/* outside */}
        {/* <Rect x={1150} y={30} width={100} height={40} stroke="black" strokeWidth={1} /> */}
        {/* <Text x={1170} y={30} text={"WHM"} padding={15} lineHeight={0.75} align="center" /> */}
        <LoadImage src="/img/whm.png" x={1140} y={15} width={100 / 1.5} height={98 / 1.5} />

        {/* <Rect x={1150} y={100} width={100} height={40} stroke="black" strokeWidth={1} /> */}
        {/* <Text x={1170} y={100} text={"OVGR\n\n信号"} padding={8} lineHeight={0.75} align="center" /> */}
        <LoadImage src="/img/ovgr.png" x={1140} y={90} width={139 / 2.5} height={170 / 2.5} />

        <Rect x={1150} y={170} width={100} height={40} stroke="black" strokeWidth={1} />
        <Text x={1170} y={170} text={"マルチ\n\nメータ"} padding={8} lineHeight={0.75} align="center" />

        {/* <Rect x={1150} y={230} width={100} height={40} stroke="black" strokeWidth={1} /> */}
        {/* <Text x={1170} y={230} text={"50kW\n\nPCS"} padding={8} lineHeight={0.75} align="center" /> */}
        <LoadImage src="/img/pcs.png" x={1140} y={220} width={100 / 1.5} height={132 / 1.5} />

        <Text x={420} y={-20} text={"9.通信機器収納盤"} />
        <Text x={590} y={450} text={"インターネットへ"} />

    </Group>
}

const stepdownTransformer = (x, y) => {
    return <Group x={x} y={y}>
        <LoadImage src="/img/stepdown.png" x={49} width={400 / 2} height={359 / 2} fill="#d9e6ff" />
        <Text x={110} y={-15} text={"10.降圧トランス盤"} />
        <Text x={120} y={80} text={"降圧トラン\n\n303W\t\t50KVA\t\t210/420V"} lineHeight={0.65} fontSize={10} />
        <Text x={120} y={150} text={"ELCB\n\n100AT"} lineHeight={0.65} fontSize={10} />
        <Text x={120} y={30} text={"MCCB\n\n225AT"} lineHeight={0.65} fontSize={10} />

        <Line points={[100, 170, 100, 520]} stroke="black" strokeWidth={1} />
        <Line points={[100, 320, 250, 320]} stroke="black" strokeWidth={1} />
        <LoadImage src="/img/battery.png" x={70} y={300} width={228 / 4} height={189 / 4} fill="#d9e6ff" />
        <LoadImage src="/img/panel.png" x={50} y={500} width={418 / 4} height={188 / 4} fill="#d9e6ff" />

        <Rect x={250} y={300} width={160} height={40} stroke="black" strokeWidth={1} />

        <Text x={250} y={300} text={"通信機器収納版\n\nインターネットスイッチへ"} lineHeight={0.65} padding={10} fontSize={11} />

        {/* Line labels */}
        <Text x={80} y={300} text={"600V-CVT-==sq"} lineHeight={0.65} padding={10} fontSize={11} rotation={270} />
        <Text x={80} y={500} text={"1500V-PV-CQ-==sq"} lineHeight={0.65} padding={10} fontSize={11} rotation={270} />
        <Text x={150} y={300} text={"LAN"} lineHeight={0.65} padding={10} fontSize={11} />
        <Text x={-100} y={280} text={"2.PCS1\t\t50kW/=30kW出力制御"} lineHeight={0.65} padding={10} fontSize={11} />
        <Text x={-30} y={480} text={"1.PVSTRINGS"} lineHeight={0.65} padding={10} fontSize={11} />
        <Text x={-30} y={550} text={"ストリング構成\n\n１８直列ｘ4入力\n\nPV合計出力:28.8kW\n\nPV合計出力:72枚"} lineHeight={0.65} padding={10} fontSize={11} />
    </Group>
};

const moduleSet = (x, y, { battery, panel, pcs1, pcs2, line1, line2, line3, line4, line5, pv, acCollector, count, extra }, isConnected, dashed, handleClick) => {
    return <Group x={x} y={y} >
        {/* pcs vertical  1*/}
        <Line stroke="black" strokeWidth={1} points={[100, 125, 400, 126]} />
        {/* pcs vertical 2 */}
        <Line stroke="black" strokeWidth={1} points={[149, 250, 400, 249.5]} />
        {/* mccb */}
        <Line stroke="black" strokeWidth={1.25} points={[660, 187.5, 750, 187.5]} />
        {/* vertical line */}
        {/* {dashed ? <Line stroke="black" strokeWidth={1} points={verticalSickle(298, -60, 150)} dash={[8]} /> :
            <Line stroke="black" strokeWidth={1} points={verticalSickle(298, -60, 150)} />
        } */}
        {dashed ? <Line stroke="black" strokeWidth={1} points={verticalSickle(298, -180, -70)} dash={[8]} /> :
            <Line stroke="black" strokeWidth={1} points={verticalSickle(298, -180, -70)} />
        }
        {isConnected ?
            dashed ? <Line stroke="black" strokeWidth={1} points={verticalSickle(298, -60, 150)} dash={[8]} /> :
                <Line stroke="black" strokeWidth={1} points={verticalSickle(298, -60, 150)} /> :
            null
        }

        {/* Line text */}

        <Text x={170} y={110} text={line1} fontSize={9.5} />
        <Text x={320} y={110} text={line2} fontSize={9.5} />
        <Text x={160} y={230} text={line3} fontSize={9.5} />
        <Text x={320} y={235} text={line4} fontSize={9.5} />
        <Text x={340} y={180} text={"LAN"} fontSize={9.5} />
        {isConnected && <Text x={340} y={330} text={"LAN"} fontSize={9.5} />}

        <Circle x={200} y={260} radius={3} fill="black" />
        <Circle x={200} y={275} radius={3} fill="black" />
        <Circle x={200} y={290} radius={3} fill="black" />
        <Text x={170} y={300} text={pv} fontSize={9.5} />

        <Text x={80} y={80} text={battery} />
        <LoadImage src="/img/solar.png" x={100} y={105} width={228 / 4} height={189 / 4} fill="#d9e6ff" />

        <Text x={240} y={90} text={pcs1} onClick={() => handleClick('battery')} onMouseEnter={cursorPoint} onMouseLeave={cursorNormal} fill="blue" textDecoration="underline" />
        <LoadImage src="/img/battery.png" x={250} y={105} width={228 / 4} height={189 / 4} fill="#d9e6ff" />

        <Text x={70} y={170} text={panel} lineHeight={0.75} onClick={() => handleClick('pcs')} onMouseEnter={cursorPoint} onMouseLeave={cursorNormal} fill="blue" textDecoration="underline" />
        <LoadImage src="/img/panel.png" x={50} y={226.5} width={418 / 4} height={188 / 4} />

        <Text x={240} y={210} text={pcs2} onClick={() => handleClick('battery')} onMouseEnter={cursorPoint} onMouseLeave={cursorNormal} fill="blue" textDecoration="underline" />
        <LoadImage src="/img/battery.png" x={250} y={225} width={228 / 4} height={189 / 4} fill="#d9e6ff" />

        <Text x={420} y={80} text={"7.自動運転切替盤"} />
        {isConnected && <>
            <Text x={450} y={340} text={"特定負荷用分電盤へ\n\n通常時負荷8kW\n\n停電時負荷4kW"} lineHeight={0.75} />
            <Line stroke="black" strokeWidth={1} points={[497, 280, 497, 330, 502, 310, 492, 320]} />
        </>}

        <LoadImage src="/img/elcb.png" x={400} y={95} width={799 / 3} height={559 / 3} fill="#d9e6ff" />

        <Text x={770} y={145} text={"8.交流集電盤"} />
        <Text x={680} y={175} text={line5} fontSize={9.5} />

        <Circle x={710} y={210} radius={3} fill="black" />
        <Circle x={710} y={225} radius={3} fill="black" />
        <Circle x={710} y={195} radius={2} fill="black" />
        <Text x={665} y={240} text={count} fontSize={9.5} />

        {(acCollector === 'mccb4') && <LoadImage src={`/img/${acCollector}.png`} x={750} y={160} width={719 / 2.5} height={384 / 2.5} fill="#d9e6ff" />}
        {(acCollector === 'mccb3') && <LoadImage src={`/img/${acCollector}.png`} x={750} y={160} width={719 / 2.5} height={384 / 2.5} fill="#d9e6ff" />}
        {(acCollector === 'mccb2') && <LoadImage src={`/img/${acCollector}.png`} x={750} y={164.5} width={719 / 3} height={384 / 3} fill="#d9e6ff" />}

        {(extra !== null) && <Text x={630} y={290} text={extra} fontSize={9.5} />}

        {(!isConnected) && <>
            <Line stroke="black" strokeWidth={0.75} points={[497, 250, 497, 371]} />
            <Text x={460} y={520} text={"通信機器収納盤\n\nUPSへ"} />
            <Text x={580} y={520} text={"特定負荷用分電盤へ\n\n通常時負荷※Kw\n\n停電時負荷※kW"} />
            <Text x={500} y={355} text={"11.UPS用分電盤"} />
            <LoadImage src="/img/vmccb2.png" x={475.5} y={370} width={675 / 3} height={398 / 3} />
        </>}


    </Group>;
};

const renderPcs = (data, x, y, setSelected, goToInfo, count) => {
    let originLine = 360;
    let originAxis = 600;
    const result = [];

    const handleSelectUnit = (index) => {
        setSelected({ data: [data[index], data[index + 1]], device_id: "unit" })
        // if (data[index]?.device_id.startsWith("PV")) {
        //     const count = data[index]?.device_id.toString().split('PVPCS')[1]
        //     setSelected({ ...data[index], device_id: "Unit" + count, device_id: "unit" + count })
        // } else {
        //     const count = data[index]?.device_id.toString().split('BTPCS')[1]
        //     setSelected({ ...data[index], device_id: "Unit" + count, device_id: "unit" + count })
        // }

    }
    const processDeviceId = (device_id) => {
        let unit = device_id.toString().split('BTPCS');
        if (unit[1].includes('A')) {
            return "Unit " + unit[1].split('A')[0];
        } else {
            return "Unit " + unit[1];
        }
    }


    if (data.length === 0) {
        return null;
    }

    if (data.length >= 2) {
        result.push([
            <Line points={[70, 30, 70, 60]} stroke="black" />,
            <Rect width={160} height={30} stroke="black" strokeWidth={1} fill="#fff" />,
            <Text text={'交流集電箱'} fontVariant="bold" fontSize={13} padding={10} x={30} />,
            <Group x={0} y={60}>
                {/* unit  */}
                <Rect x={-15} y={-10} width={250} height={140} stroke="black" strokeWidth={1} dash={[7, 7]} />
                <Text
                    // text={"Unit " + data[0]?.device_id.toString().split('BTPCS')[1]}
                    text={processDeviceId(data[0]?.device_id)}
                    fontSize={13}
                    x={170}
                    y={106}
                    fill="blue"
                    textDecoration="underline"
                    onMouseEnter={cursorPoint}
                    // onClick={() => goToInfo({
                    //     value: "Unit " + data[0]?.device_id.toString().split('BTPCS')[1],
                    //     length: count
                    // })}
                    onClick={(e) =>
                        handleSelectUnit(0)
                        // setSelected({ ...data[0], device_id: "Unit1", device_id: "Unit " + data[0]?.device_id.toString().split('BTPCS')[1] })
                    }
                    onMouseLeave={cursorNormal} />


                <Rect width={120} height={30} stroke="black" strokeWidth={1} fill="#fff" />
                <Text text={'切替盤'} fontVariant="bold" fontSize={13} padding={10} x={25} y={0} />
                {/* Battery */}
                <Group x={0} y={50}>
                    <Line points={[20, -20, 20, 0]} stroke="black" />
                    <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                    <Text
                        x={-10}
                        y={40}
                        text={data[0]?.device_id.toString()}
                        lineHeight={0.675}
                        fill="blue"
                        textDecoration="underline"
                        onClick={(e) => setSelected(data[0])}
                        onMouseEnter={cursorPoint}
                        onMouseLeave={cursorNormal}
                    />
                </Group>
                {/* PV */}
                <Group x={80} y={50}>
                    <Line points={[20, -20, 20, 0]} stroke="black" />
                    <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                    <Text
                        x={0}
                        y={40}
                        text={data[1]?.device_id.toString()}
                        lineHeight={0.675}
                        fill="blue"
                        textDecoration="underline"
                        onClick={(e) => setSelected(data[1])}

                        onMouseEnter={cursorPoint}
                        onMouseLeave={cursorNormal}
                    />
                </Group>
                {/* Specific Load */}
                <Group x={150} y={50}>
                    <Line points={[-30, -35, 30, -35, 30, 0]} stroke="black" />
                    <Rect width={70} height={30} stroke="black" strokeWidth={1} fill="#fff" />
                    <Text
                        x={0}
                        y={0}
                        text={'特定負荷'}
                        fill="black"
                        fontStyle="bold"
                        fontSize={13}
                        padding={10}
                    />
                </Group>
            </Group>
        ]);
    }

    if (data.length >= 4) {
        result.push([
            <Line points={[160, 20, 360, 20, 360, 60]} stroke="black" />,
            <Group x={300} y={60}>
                {/* unit  */}
                <Rect x={-30} y={-10} width={260} height={140} stroke="black" strokeWidth={1} dash={[7, 7]} />
                <Text
                    // text={"Unit " + data[2]?.device_id.toString().split('BTPCS')[1]}
                    text={processDeviceId(data[2]?.device_id)}

                    fontSize={13}
                    x={170}
                    y={106}
                    fill="blue"
                    textDecoration="underline"
                    onMouseEnter={cursorPoint}
                    // onClick={() => goToInfo({
                    //     value: "Unit " + data[2]?.device_id.toString().split('BTPCS')[1],
                    //     length: count
                    // })}
                    onClick={(e) =>
                        handleSelectUnit(
                            2
                        )
                        // setSelected({ ...data[1], device_id: "Unit2", device_id: "Unit " + data[1]?.device_id.toString().split('BTPCS')[1] })
                    }
                    onMouseLeave={cursorNormal} />

                <Rect width={120} height={30} stroke="black" strokeWidth={1} fill="#fff" />
                <Text text={'切替盤'} fontVariant="bold" fontSize={13} padding={10} x={25} y={0} />
                {/* battery */}
                <Group x={0} y={50}>
                    <Line points={[20, -20, 20, 0]} stroke="black" />
                    <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                    <Text
                        x={-20}
                        y={40}
                        text={data[2]?.device_id.toString()}
                        lineHeight={0.675}
                        fill="blue"
                        textDecoration="underline"
                        onClick={(e) => setSelected(data[2])}
                        onMouseEnter={cursorPoint}
                        onMouseLeave={cursorNormal}
                    />
                </Group>
                {/* PV */}
                <Group x={80} y={50}>
                    <Line points={[20, -20, 20, 0]} stroke="black" />
                    <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                    <Text
                        x={0}
                        y={40}
                        text={data[3]?.device_id.toString()}
                        lineHeight={0.675}
                        fill="blue"
                        textDecoration="underline"
                        onClick={(e) => setSelected(data[3])}
                        onMouseEnter={cursorPoint}
                        onMouseLeave={cursorNormal}
                    />
                </Group>
                {/* Specific Load */}
                <Group x={150} y={50}>
                    <Line points={[-30, -35, 30, -35, 30, 0]} stroke="black" />
                    <Rect width={70} height={30} stroke="black" strokeWidth={1} fill="#fff" />
                    <Text
                        x={0}
                        y={0}
                        text={'特定負荷'}
                        fill="black"
                        fontStyle="bold"
                        fontSize={13}
                        padding={10}
                    />
                </Group>
            </Group>
        ]);
    }

    if (data.length > 4) {
        // Connection line
        for (let i = 4; i < data.length - 1; i += 2) {
            result.push([
                <Line points={[originLine, 20, originLine + 300, 20, originLine + 300, 60]} stroke="black" />,
                <Group x={originAxis} y={60}>
                    {/* unit  */}
                    <Rect x={-30} y={-10} width={270} height={140} stroke="black" strokeWidth={1} dash={[7, 7]} />
                    <Text
                        // text={"Unit " + data[i]?.device_id.toString().split('BTPCS')[1]}
                        text={processDeviceId(data[i]?.device_id)}
                        fontSize={13}
                        x={170}
                        y={106}
                        fill="blue"
                        textDecoration="underline"
                        onMouseEnter={cursorPoint}
                        // onClick={() => goToInfo({
                        //     value: "Unit " + data[i]?.device_id.toString().split('BTPCS')[1],
                        //     length: count
                        // })}
                        onClick={(e) =>
                            handleSelectUnit(i)
                            // setSelected({ ...data[2], device_id: "Unit3", device_id: "Unit " + data[1]?.device_id.toString().split('BTPCS')[1] })
                        }
                        onMouseLeave={cursorNormal} />

                    <Rect width={120} height={30} stroke="black" strokeWidth={1} fill="#fff" />
                    <Text text={'切替盤'} fontVariant="bold" fontSize={13} padding={10} x={25} y={0} />
                    {/* Battery */}
                    <Group x={0} y={50}>
                        <Line points={[20, -20, 20, 0]} stroke="black" />
                        <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                        <Text
                            x={-20}
                            y={40}
                            text={data[i]?.device_id.toString()}
                            lineHeight={0.675}
                            fill="blue"
                            textDecoration="underline"
                            onClick={(e) => setSelected(data[i])}
                            onMouseEnter={cursorPoint}
                            onMouseLeave={cursorNormal}
                        />
                    </Group>
                    {/* pcs */}
                    <Group x={80} y={50}>
                        <Line points={[20, -20, 20, 0]} stroke="black" />
                        <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                        <Text
                            x={0}
                            y={40}
                            text={data[i + 1]?.device_id.toString()}
                            lineHeight={0.675}
                            fill="blue"
                            textDecoration="underline"
                            onClick={(e) => setSelected(data[i + 1])}

                            onMouseEnter={cursorPoint}
                            onMouseLeave={cursorNormal}
                        />
                    </Group>
                    {/* Specific Load */}
                    <Group x={150} y={50}>
                        <Line points={[-30, -35, 30, -35, 30, 0]} stroke="black" />
                        <Rect width={70} height={30} stroke="black" strokeWidth={1} fill="#fff" />
                        <Text
                            x={0}
                            y={0}
                            text={'特定負荷'}
                            fill="black"
                            fontStyle="bold"
                            fontSize={13}
                            padding={10}
                        />
                    </Group>
                </Group>
            ]);
            originLine += 300;
            originAxis += 300;
        }
    }

    return <Group x={x} y={y} >
        {result}
    </Group>
};

const getColor = (data) => {
    if (data && !!data) {
        if (data.work_status === 0) {
            return '#548235';
        } else if (data.work_status === 1) {
            return '#BD1D1D';
        } else {
            return '#F6BE00';
        }
    }
};

const renderHybridPcs = (deviceList) => {
    if (deviceList.hybridPcs !== null) {
        const color = getColor(deviceList.hybridPcs[0]);
        return (<>
            <Rect x={-130} y={-180} width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={color} />
            <Line stroke={color} strokeWidth={5} x={-110} y={-225} points={[310, 60, 130, 60]} dash={[10, 10]} />
            <Text x={-130} y={-175} text={deviceList.hybridPcs[0]?.device_id.toString()} fill="white" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
            <Text x={70} y={-160} text={deviceList.hybridPcs[0]?.work_status > 0 ? deviceList.hybridPcs[0].work_status.toString() : null} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
            <Text x={40} y={-200} text={deviceList.hybridPcs[0]?.ip_address.toString()} fill="black" fontStyle="bold" fontSize={15} padding={10} lineHeight={0.75} />
        </>
        );
    }
    return null;
};

const renderPcsComn = (data, x, y, alignment) => {
    let originLine = (alignment === 'right' || alignment === 'right1') ? 350 : 0;
    let originAxis = alignment === 'left' || alignment === 'left1' ? 350 : 0;
    const val = [];

    if (data.length === 0) {
        return null;
    }

    if (alignment === 'right') {

        if (data.length >= 1) {
            val.push([
                <Group x={0} y={0}>
                    <Line stroke={getColor(data[0])} strokeWidth={5} points={[160, 25, originLine, 25]} dash={[10, 10]} />
                    <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[0])} />
                    <Text text={data[0]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={data[0]?.ip_address.toString()} x={170} y={-10} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={(data[0]?.work_status > 0) ? data[0]?.work_status.toString() : null} x={200} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                </Group>
            ]);
        }

        if (data.length > 1) {
            for (let i = 1; i < data.length; i++) {
                val.push([
                    <Group x={originAxis - 200} y={0}>
                        <Line stroke={getColor(data[i])} strokeWidth={5} points={[60, 25, 200, 25]} dash={[10, 10]} />
                        <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[i])} />
                        <Text text={data[i]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={data[i]?.ip_address.toString()} x={130} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={(data[i]?.work_status > 0) ? data[i]?.work_status.toString() : null} x={150} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                    </Group>
                ]);
                originAxis -= 200;
            }
        }
    }

    if (alignment === 'left') {

        if (data.length >= 1) {
            val.push([
                <Group x={0} y={0}>
                    <Line stroke={getColor(data[0])} strokeWidth={5} points={[0, -125, -50, -125, -50, 20, 0, 20]} dash={[10, 10]} />
                    <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[0])} />
                    <Text text={data[0]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={data[0]?.ip_address.toString()} x={-50} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={(data[0]?.work_status > 0) ? data[0]?.work_status.toString() : null} x={-50} y={20} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                </Group>
            ]);
        }

        if (data.length > 1) {
            originAxis -= 150;
            for (let i = 1; i < data.length; i++) {
                val.push([
                    <Group x={originAxis} y={0}>
                        <Line stroke={getColor(data[i])} strokeWidth={5} points={[-40, 25, 50, 25]} dash={[10, 10]} />
                        <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[i])} />
                        <Text text={data[i]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={data[i]?.ip_address.toString()} x={-70} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={(data[i]?.work_status > 0) ? data[i]?.work_status.toString() : null} x={-50} y={25} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                    </Group>
                ]);
                originAxis += 200
            }

        }
    }
    if (alignment === 'right1') {

        if (data.length >= 1) {
            val.push([
                <Group x={0} y={0}>
                    <Line stroke={getColor(data[2])} strokeWidth={5} points={[60, -130, 60, 20]} dash={[10, 10]} />
                    <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[2])} />
                    <Text text={data[0]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={data[0]?.ip_address.toString()} x={80} y={-90} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={(data[0]?.work_status > 0) ? data[0]?.work_status.toString() : null} x={5} y={-90} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                </Group>
            ]);
        }

        if (data.length > 1) {
            for (let i = 1; i < data.length; i++) {
                val.push([
                    <Group x={originAxis - 200} y={0}>
                        <Line stroke={getColor(data[i])} strokeWidth={5} points={[100, 25, 200, 25]} dash={[10, 10]} />
                        <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[i])} />
                        <Text text={data[i]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={data[i]?.ip_address.toString()} x={110} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={(data[i]?.work_status > 0) ? data[i]?.work_status.toString() : null} x={150} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    </Group>
                ]);
                originAxis -= 200;
            }
        }
    }

    if (alignment === 'left1') {

        if (data.length >= 1) {
            val.push([
                <Group x={0} y={0}>
                    <Line stroke={getColor(data[0])} strokeWidth={5} points={[0, -145, -50, -145, -50, 20, 0, 20]} dash={[10, 10]} />
                    <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[0])} />
                    <Text text={data[0]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={data[0]?.ip_address.toString()} x={-50} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={(data[0]?.work_status > 0) ? data[0]?.work_status.toString() : null} x={-50} y={20} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                </Group>
            ]);
        }
        if (data.length > 1) {
            originAxis -= 150;
            for (let i = 1; i < data.length; i++) {
                val.push([
                    <Group x={originAxis} y={0}>
                        <Line stroke={getColor(data[i])} strokeWidth={5} points={[-40, 25, 50, 25]} dash={[10, 10]} />
                        <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[i])} />
                        <Text text={data[i]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={data[i]?.ip_address.toString()} x={-75} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={(data[i]?.work_status > 0) ? data[i]?.work_status.toString() : null} x={-50} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                    </Group>
                ]);
                originAxis += 200
            }
        }
    }

    if (alignment === 'iwaneright') {

        if (data.length >= 1) {
            val.push([
                <Group x={0} y={0}>
                    <Line stroke={getColor(data[0])} strokeWidth={5} points={[350, 20, originLine, 20]} dash={[10, 10]} />
                    <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[0])} />
                    <Text text={data[0]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={data[0]?.ip_address.toString()} x={170} y={-10} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={(data[0]?.work_status > 0) ? data[0]?.work_status.toString() : null} x={200} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                </Group>
            ]);
        }

        if (data.length > 1) {
            for (let i = 1; i < data.length; i++) {
                val.push([
                    <Group x={originAxis - 200} y={0}>
                        <Line stroke={getColor(data[i])} strokeWidth={5} points={[60, 25, 200, 25]} dash={[10, 10]} />
                        <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[i])} />
                        <Text text={data[i]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={data[i]?.ip_address.toString()} x={130} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={(data[i]?.work_status > 0) ? data[i]?.work_status.toString() : null} x={150} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                    </Group>
                ]);
                originAxis -= 200;
            }
        }
    }
    if (alignment === 'iwaneleft') {

        if (data.length >= 1) {
            val.push([
                <Group x={0} y={0}>
                    <Line stroke={getColor(data[0])} strokeWidth={5} points={[60, -70, 60, 20,]} dash={[10, 10]} />
                    <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[0])} />
                    <Text text={data[0]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={data[0]?.ip_address.toString()} x={-50} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={(data[0]?.work_status > 0) ? data[0]?.work_status.toString() : null} x={-50} y={20} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                </Group>
            ]);
        }
        if (data.length > 1) {
            originAxis -= 200;
            for (let i = 1; i < data.length; i++) {
                val.push([
                    <Group x={originAxis + 400} y={0}>
                        <Line stroke={getColor(data[i])} strokeWidth={5} points={[-40, 25, 50, 25]} dash={[10, 10]} />
                        <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[i])} />
                        <Text text={data[i]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={data[i]?.ip_address.toString()} x={-75} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={(data[i]?.work_status > 0) ? data[i]?.work_status.toString() : null} x={-50} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                    </Group>
                ]);
                originAxis += 200
            }
        }
    }

    if (alignment === 'KICright') {

        if (data.length >= 1) {
            val.push([
                <Group x={0} y={0}>
                    {/* <Line stroke={getColor(data[0])} strokeWidth={5} points={[350, 20, originLine, 20]} dash={[10, 10]} /> */}
                    <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[0])} />
                    <Text text={data[0]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={data[0]?.ip_address.toString()} x={150} y={-15} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                    <Text text={(data[0]?.work_status > 0) ? data[0]?.work_status.toString() : null} x={200} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                </Group>
            ]);
        }

        if (data.length > 1) {
            for (let i = 1; i < data.length; i++) {
                val.push([
                    <Group x={0} y={originAxis + 70}>
                        <Line stroke="#548235" strokeWidth={5} x={200} y={-80} points={[-50, 30, 10, 70, 10, 100, -50, 100]} dash={[10, 10]} />
                        <Rect width={150} strokeWidth={1} height={40} stroke="#4B752F" fill={getColor(data[i])} />
                        <Text text={data[i]?.device_id} fill="white" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={data[i]?.ip_address.toString()} x={90} y={-30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />
                        <Text text={(data[i]?.work_status > 0) ? data[i]?.work_status.toString() : null} x={150} y={30} fill="black" fontStyle="bold" fontSize={18} padding={10} lineHeight={0.75} />

                    </Group>
                ]);
                originAxis += 70;
            }
        }
    }

    return <Group x={x} y={y} >
        {val}
    </Group>
};

const renderonlyPcs = (data, x, y, setSelected, goToInfo, count, alignment) => {
    let originLine = 238;
    let originAxis = 240;
    const result = [];
    // const handleSelectUnit = (index) => {
    //     console.log('data[index]', data[index])
    //     if (data[index]?.device_id.startsWith("PV")) {
    //         const count = data[index]?.device_id.toString().split('PVPCS')[1]
    //         setSelected({ ...data[index], device_id: "Unit" + count, device_id: "unit" + count })
    //     } else {
    //         const count = data[index]?.device_id.toString().split('BTPCS')[1]
    //         setSelected({ ...data[index], device_id: "Unit" + count, device_id: "unit" + count })
    //     }

    // }

    if (data.length === 0) {
        return null;
    }
    if (data.length >= 1) {
        if (data.length === 1 && (alignment === 'sayama' || alignment === 'hokkaido')) {
            result.push([
                <Line points={[15, 25, 15, 90]} stroke="black" dash={[15, 10]} />,
                <Group x={45} y={60}>
                    {/* <Line points={[-30, 14, 0, 14]} stroke="black" /> */}
                    {/* PV */}
                    <Group x={-50} y={25}>
                        {/* <Line points={[20, -20, 20, 0]} stroke="black" /> */}
                        <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                        <Text
                            x={0}
                            y={40}
                            text={data[0]?.device_id.toString()}
                            lineHeight={0.675}
                            fill="blue"
                            textDecoration="underline"
                            onClick={(e) => setSelected(data[0])}

                            onMouseEnter={cursorPoint}
                            onMouseLeave={cursorNormal}
                        />
                    </Group>
                </Group>
            ]);
        } else {
            result.push([
                <Line points={[15, 30, 15, 75]} stroke="black" dash={[15, 15]} />,
                <Group x={45} y={60}>
                    <Line points={[-30, 14, 0, 14]} stroke="black" />
                    {/* PV */}
                    <Group x={-5} y={0}>
                        {/* <Line points={[20, -20, 20, 0]} stroke="black" /> */}
                        <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                        <Text
                            x={0}
                            y={40}
                            text={data[0]?.device_id.toString()}
                            lineHeight={0.675}
                            fill="blue"
                            textDecoration="underline"
                            onClick={(e) => setSelected(data[0])}

                            onMouseEnter={cursorPoint}
                            onMouseLeave={cursorNormal}
                        />
                    </Group>
                </Group>
            ]);
        }
    }

    if (data.length >= 2) {
        result.push([
            <Line points={[0, 30, 0, 180]} stroke="black" dash={[15, 15]} />,
            <Line y={-10} points={[0, 30, 0, 10]} stroke="black" />,
            <Group x={45} y={150}>
                <Line points={[-45, 14, 0, 14]} stroke="black" />
                {/* PV */}
                <Group x={-5} y={0}>
                    {/* <Line points={[20, -20, 20, 0]} stroke="black" /> */}
                    <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                    <Text
                        x={0}
                        y={40}
                        text={data[1]?.device_id.toString()}
                        lineHeight={0.675}
                        fill="blue"
                        textDecoration="underline"
                        onClick={(e) => setSelected(data[1])}
                        onMouseEnter={cursorPoint}
                        onMouseLeave={cursorNormal}
                    />
                </Group>
            </Group>
        ]);
    }

    if (data.length > 2) {
        let line1 = -15;
        let line2 = -60;
        // Connection line
        for (let i = 1; i < data.length - 1; i++) {
            result.push([
                <Line points={[line1, 30, line1, originLine + 16]} stroke="black" dash={[15, 15]} />,
                <Line y={-10} points={[line1, 30, line1, 10]} stroke="black" />,
                <Group x={45} y={originAxis}>
                    <Line points={[line2, 14, 0, 14]} stroke="black" />
                    {/* pcs */}
                    <Group x={-5} y={0}>
                        {/* <Line points={[20, -20, 20, 0]} stroke="black" /> */}
                        <LoadImage src="/img/battery.png" height={28} width={40} fill="lightgreen" />
                        <Text
                            x={0}
                            y={40}
                            text={data[i + 1]?.device_id.toString()}
                            lineHeight={0.675}
                            fill="blue"
                            textDecoration="underline"
                            onClick={(e) => setSelected(data[i])}

                            onMouseEnter={cursorPoint}
                            onMouseLeave={cursorNormal}
                        />
                    </Group>
                </Group>
            ]);
            originLine += 95;
            originAxis += 90;
            line1 += -15;
            line2 += -15;
        }
    }

    return <Group x={x} y={y} >
        {result}
    </Group>
};

export {
    handleStageDragStart,
    handleStageDragMove,
    handleStageDragMoveKiyomidai,
    handleStageDragMoveFukida,
    handleStageDragMoveOta,
    handleStageDragMoveHatazawa,
    handleStageDragMoveJunior,
    handleStageDragMoveJozai,
    handleStageWheel,
    handleStageDragMoveComn,
    handleStageDragMoveOtaComn,
    handleStageDragMoveFukidaComn,
    handleStageDragMoveJozaiComn,
    cursorPoint,
    cursorNormal,
    cursorGrab,
    chiefMCCB,
    commDevice,
    stepdownTransformer,
    moduleSet,
    renderPcs,
    renderPcsComn,
    renderHybridPcs,
    renderonlyPcs,
    handleStageDragMoveSayama,
    handleStageDragMoveKoshigaya,
    handleStageDragMoveIwane
};